module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('YesNo', {
    attrs: {
      "label": _vm.schema.label,
      "question": _vm.schema.question,
      "color": "blue",
      "value": _vm.value[_vm.schema.name]
    },
    on: {
      "input": function($event) {
        return _vm.$emit('change', $event)
      },
      "focus": function($event) {
        return _vm.$emit('focus', $event)
      }
    },
    nativeOn: {
      "contextmenu": function($event) {
        $event.preventDefault();
        return _vm.$emit('focus', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7a882e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/blocks/YesNoControl.vue
// module id = 2470
// module chunks = 1